// https://medium.com/swlh/using-react-hooks-to-sync-your-component-state-with-the-url-query-string-81ccdfcb174f

import { default as qs } from 'query-string';
import { useCallback, useState } from 'react';

export const useQueryString = (key: string, initialValue?: any, addHistoryRecord?: boolean) => {
  const [value, setValue] = useState(getQueryStringValue(key) || initialValue);
  const onSetValue = useCallback(
    (newValue) => {
      setValue(newValue);
      setQueryStringValue(key, newValue, addHistoryRecord);
    },
    [key],
  );

  return [value, onSetValue];
};

export default useQueryString;

const prepareHref = (qsValue: string) => `${window.location.protocol}//${window.location.host}${window.location.pathname}?${qsValue}`;

const setQueryStringWithoutPageReload = (qsValue: string) => {
  const newurl = prepareHref(qsValue);
  window.history.replaceState({ path: newurl }, '', newurl);
};

const setQueryStringWithHistoryChange = (qsValue: string) => {
  const newurl = prepareHref(qsValue);
  window.history.pushState({ path: newurl }, '', newurl);
};

export const setQueryStringValue = (key: string, value: any, addHistoryRecord: boolean) => {
  const values = qs.parse(window.location.search);

  const newQsValue = qs.stringify({ ...values, [key]: value });
  if (addHistoryRecord) {
    setQueryStringWithHistoryChange(newQsValue);
  } else {
    setQueryStringWithoutPageReload(newQsValue);
  }
};

export const getQueryStringValue = (key: string) => {
  const values = qs.parse(window.location.search);
  return values[key];
};
